import React from 'react';
import { FaGithub, FaInstagram, FaLinkedin, FaFacebookF } from 'react-icons/fa';
import ProfileImage from '../ProfileImage/ProfileImage';
import ContactButton from '../ContactButton/ContactButton';
import AnimatedBackground from '../AnimatedBackground/AnimatedBackground';
import '../../assets/fonts/fonts.css';

const ProfileCard = ({ data }) => {
  const {
    name = "Seu Nome",
    title = "Programador & Tatuador",
    description = "Desenvolvedor Front-End (React, CSS) e Artista de Tatuagem.",
    city = "Sua Cidade",
    email,
    phone,
    photo,
    socialLinks = {}
  } = data || {};
  return (
    <>
    <AnimatedBackground />
    <div className="min-h-screen bg-gradient-to-br from-gray-800 via-gray-900 to-black flex items-center justify-center p-4">
      <div className="relative bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 overflow-hidden">
        
        {/* Decoração de fundo - Tatuagem esquerda */}
        <div className="absolute top-0 left-0 w-32 h-32 opacity-10">
          <svg viewBox="0 0 100 100" className="text-gray-400">
            <path d="M20,80 Q20,20 50,20 T80,80" stroke="currentColor" strokeWidth="2" fill="none"/>
            <circle cx="50" cy="30" r="8" fill="currentColor"/>
            <path d="M45,38 L55,38 L52,70 L48,70 Z" fill="currentColor"/>
          </svg>
        </div>

        {/* Decoração de fundo - Tatuagem direita */}
        <div className="absolute top-0 right-0 w-40 h-40 opacity-10">
          <svg viewBox="0 0 100 100" className="text-gray-400">
            <rect x="40" y="20" width="20" height="30" fill="none" stroke="currentColor" strokeWidth="2"/>
            <path d="M30,50 L70,50 M35,60 L65,60 M40,70 L60,70" stroke="currentColor" strokeWidth="2"/>
            <circle cx="50" cy="15" r="5" fill="currentColor"/>
          </svg>
        </div>

        {/* Decoração inferior direita */}
        <div className="absolute bottom-4 right-4 w-24 h-24 opacity-10">
          <svg viewBox="0 0 100 100" className="text-gray-400">
            <path d="M30,30 L70,30 L70,70 L30,70 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
            <line x1="50" y1="30" x2="50" y2="70" stroke="currentColor" strokeWidth="2"/>
            <line x1="30" y1="50" x2="70" y2="50" stroke="currentColor" strokeWidth="2"/>
          </svg>
        </div>

        {/* Código de fundo superior esquerdo */}
        <div className="absolute top-8 left-8 text-xs text-gray-300 opacity-30 font-mono">
          <div>{'<header>'}</div>
          <div className="ml-2">{'<title>Portfolio</title>'}</div>
          <div className="ml-2">{'<meta charset="utf-8">'}</div>
          <div>{'</header>'}</div>
        </div>

        {/* Código de fundo inferior esquerdo */}
        <div className="absolute bottom-16 left-8 text-xs text-gray-300 opacity-30 font-mono">
          <div>{'<body>'}</div>
          <div className="ml-2">{'<main>'}</div>
          <div className="ml-4">{'<section>'}</div>
          <div>{'</body>'}</div>
        </div>

        {/* Conteúdo Principal */}
        <div className="relative z-10">
          {/* Foto de Perfil */}
          <div className="mb-6">
            <ProfileImage 
              src={photo}
              alt={name}
              size="large"
            />
          </div>

          {/* Nome e Título */}
          <div className="text-center mb-6">
            <h1 className="text-4xl font-bold text-gray-800 mb-2">
              <span style={{ fontFamily: 'LogoFont, sans-serif' }}>{name}</span>
            </h1>
            <p className="text-gray-600 font-medium">
              {title}
            </p>
          </div>

          {/* Descrição */}
          <div className="text-center mb-6">
            <p className="text-gray-600 text-sm leading-relaxed">
              {description}
              {city && <span className="font-semibold"> {city}</span>}.
            </p>
          </div>

          {/* Botão de Contato */}
          <div className="mb-6">
            <ContactButton 
              email={email}
              phone={phone}
              variant="compact"
            />
          </div>

          {/* Redes Sociais */}
          <div className="flex justify-center gap-6">
            {socialLinks.github && (
              <a 
                href={socialLinks.github}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors duration-300 text-2xl"
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
            )}
            {socialLinks.instagram && (
              <a 
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-fuchsia-500 transition-colors duration-300 text-2xl"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
            )}
            {socialLinks.linkedin && (
              <a 
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-700 transition-colors duration-300 text-2xl"
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
            )}
            {socialLinks.facebook && (
              <a 
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-800 transition-colors duration-300 text-2xl"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>
            )}
          </div>
        </div>
      </div>

      {/* Estrela decorativa */}
      <div className="absolute bottom-8 right-8 text-white text-sm opacity-60">
        © Mood.RK
      </div>
    </div>
    </>
  );
};

export default ProfileCard;